import { render, staticRenderFns } from "./AdminAcademyList.vue?vue&type=template&id=b23080d0&scoped=true&lang=pug&"
import script from "./AdminAcademyList.vue?vue&type=script&lang=ts&"
export * from "./AdminAcademyList.vue?vue&type=script&lang=ts&"
import style0 from "./AdminAcademyList.vue?vue&type=style&index=0&id=b23080d0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23080d0",
  null
  
)

export default component.exports